module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#politics",
      toString: function () {
        return this.url;
      }
    }